import React from 'react';
import {
  VStack,
  Text,
  Box,
  Heading,
  Code,
  Button,
  useColorModeValue,
  useToast,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import { FiCopy } from 'react-icons/fi';
import { useDebugStore } from '../../../../stores/debugStore';

const PromptViewer: React.FC = () => {
  const { systemPrompt } = useDebugStore();
  const toast = useToast();
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const handleCopyPrompt = () => {
    if (systemPrompt) {
      navigator.clipboard.writeText(systemPrompt);
      toast({
        title: 'Copied to clipboard',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    }
  };

  return (
    <VStack align="stretch" spacing={4}>
      <Heading size="md">System Prompt</Heading>

      {!systemPrompt ? (
        <Box
          p={8}
          textAlign="center"
          borderWidth={1}
          borderColor={borderColor}
          borderRadius="md"
          borderStyle="dashed"
        >
          <Text color="gray.500">No system prompt generated yet</Text>
          <Text fontSize="sm" color="gray.400" mt={2}>
            The system prompt will appear here when a conversation starts
          </Text>
        </Box>
      ) : (
        <VStack align="stretch" spacing={3}>
          <Alert status="info" variant="subtle">
            <AlertIcon />
            <Text fontSize="sm">
              This is the personalized system prompt generated for the AI tutor based on your profile and current state.
            </Text>
          </Alert>

          <Box position="relative">
            <Button
              size="sm"
              leftIcon={<FiCopy />}
              variant="ghost"
              position="absolute"
              top={2}
              right={2}
              zIndex={1}
              onClick={handleCopyPrompt}
            >
              Copy
            </Button>
            <Box
              p={4}
              bg={bgColor}
              borderWidth={1}
              borderColor={borderColor}
              borderRadius="md"
              maxH="600px"
              overflowY="auto"
            >
              <Code
                display="block"
                whiteSpace="pre-wrap"
                fontSize="sm"
                bg="transparent"
                p={0}
              >
                {systemPrompt}
              </Code>
            </Box>
          </Box>
        </VStack>
      )}
    </VStack>
  );
};

export default PromptViewer;